"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInput = exports.StyledPlus = exports.StyledMinus = exports.StyledButton = exports.StyledNumericInput = void 0;
const theme_1 = require("@pulse-web-ui/theme");
const react_1 = require("react");
const Minus = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/minus'))));
const Plus = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('@pulse-web-ui/icons/lib/lazy/plus'))));
exports.StyledNumericInput = theme_1.styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2px;
  width: 100%;
  max-width: 150px;
  background: ${({ theme }) => theme.colors.neutral[10]};
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 2)}`; }};
`;
exports.StyledButton = theme_1.styled.button `
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  user-select: none;
  outline: none;
  margin: 0;
  padding: 8px;
  width: 40px;
  height: 40px;
  background: ${({ theme }) => theme.colors.neutral[0]};
  border-radius: ${({ theme }) => { var _a; return (_a = theme.common.radius12) !== null && _a !== void 0 ? _a : `calc(${theme.common.radius} * 2)}`; }};

  :not(:disabled) {
    cursor: pointer;
  }
`;
exports.StyledMinus = (0, theme_1.styled)(Minus) `
  color: ${({ theme, disabled }) => disabled ? theme.colors.icon.quaternary : theme.colors.icon.primary};
`;
exports.StyledPlus = (0, theme_1.styled)(Plus) `
  color: ${({ theme, disabled }) => disabled ? theme.colors.icon.quaternary : theme.colors.icon.primary};
`;
exports.StyledInput = theme_1.styled.input `
  ${theme_1.typography.medium18};
  width: 100%;
  padding: 0 10px;
  text-align: center;
  background: transparent;
  border: none;
  outline: none;
  letter-spacing: 0.01em;
  color: ${({ theme }) => theme.colors.text.primary};
  user-select: none;
`;
